import React from 'react';
import { Info } from 'lucide-react';

export const AirQualityLegend = () => (
  <div className="bg-white p-3 rounded-lg shadow">
    <div className="flex items-center justify-between mb-2">
      <h3 className="font-semibold text-lg">Air Quality Index (AQI)</h3>
      <Info size={16} className="text-gray-500" />
    </div>

    <div className="mb-3 p-3 bg-blue-50 rounded text-sm text-gray-700">
      <h4 className="font-medium mb-2">What are we measuring?</h4>
      <p className="leading-snug mb-2">
        PM2.5 refers to tiny particles in the air that are smaller than 2.5 micrometers - that's about 30 times smaller than a human hair! 
        These particles can come from smoke, car exhaust, or dust, and because they're so small, they can get deep into our lungs when we breathe.
      </p>
      <p className="leading-snug mb-2">
        We use the U.S. Environmental Protection Agency's (EPA) Air Quality Index (AQI) to help you understand what our air quality means for your health. 
        The AQI converts PM2.5 measurements into a simple number from 0 to 500:
      </p>
      <ul className="leading-snug list-disc pl-4 mb-2">
        <li>0-50 (Green): Air quality is good and healthy for everyone</li>
        <li>51-100 (Yellow): Air quality is okay, but some sensitive people might want to be careful</li>
        <li>Over 100 (Orange and above): Air quality might not be healthy for everyone</li>
      </ul>
      <div className="text-xs text-gray-600 mt-2 pt-2 border-t border-gray-200">
        Our measurements follow the EPA's Air Quality Index guidelines. Learn more on the EPA's{' '}
        <a 
          href="https://www.airnow.gov/aqi/aqi-basics/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-blue-600 hover:text-blue-800 underline"
        >
          AirNow website
        </a>.
      </div>
    </div>

    <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm">
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 bg-green-100 border border-green-500 rounded"></div>
        <span>Good (0-50)</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 bg-yellow-100 border border-yellow-500 rounded"></div>
        <span>Moderate (51-100)</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 bg-orange-100 border border-orange-500 rounded"></div>
        <span>Unhealthy for Sensitive Groups (101-150)</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 bg-red-100 border border-red-500 rounded"></div>
        <span>Unhealthy (151-200)</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 bg-purple-100 border border-purple-500 rounded"></div>
        <span>Very Unhealthy (201-300)</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 bg-red-200 border border-red-900 rounded"></div>
        <span>Hazardous (301+)</span>
      </div>
    </div>
  </div>
);